const HeaderScroll = () => {
  const nav = document.querySelector('header');
  const prt = nav.parentElement;
  const sticky = nav.offsetTop + 50;

  const trackScroll = () => {
    let wdth = window.innerWidth;
    if (wdth < 257) {
      if (window.pageYOffset > sticky) {
        nav.classList.add('sticky');
        prt.classList.add('menu-change');
      } else {
        nav.classList.remove('sticky');
        prt.classList.remove('menu-change');
      }
    } else {
      if (window.pageYOffset > sticky) {
        nav.classList.add('sticky');
        prt.classList.add('menu-change');
      } else {
        nav.classList.remove('sticky');
        prt.classList.remove('menu-change');
      }
    }
  };

  window.addEventListener('scroll', trackScroll);
};

export default HeaderScroll;
